import SectionHeading from '@/pages/home/components/SectionHeading';
import { mobileFeatures } from '@/mocks/cinemaData';

export default function MobileSection() {
  return (
    <section id="mobile" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="手机版"
          title="秋霞影院手机版包含哪些内容"
          desc="手机版的核心不是「把网页缩小」，而是围绕竖屏与触控重新组织信息。下面六点是手机端在浏览与观看时最常被感知到的差异。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {mobileFeatures.map((feature) => (
            <article
              key={feature.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${feature.icon} text-lg`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 rounded-lg border border-accent-300 bg-accent-100/70 p-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <i className="ri-lightbulb-line mt-0.5 text-xl text-accent-700" aria-hidden="true" />
            <p className="text-sm leading-relaxed text-foreground-700">
              <strong className="font-medium text-foreground-900">小结：</strong>
              如果主要在通勤、睡前等碎片时间使用，手机版通常更合适；如果希望更大的画面与更高的信息密度，可以继续看电脑版与网页版的差异。
            </p>
          </div>
          <a
            href="#desktop"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            看电脑版 / 网页版
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}